// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./new-dependent/styles.scss
// module id = 936
// module chunks = 0